module.exports = __webpack_public_path__ + "img/person2.3f264b49.png";